import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { DEFAULT_BLUEPRINT_ID, MODELS } from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
import { Button } from "aible";
import WarningIcon from "images/warning.svg";
const SqlWarningPopup = (props) => {
    const { show, style, isNewChat } = props;
    const dispatch = useDispatch();
    const [showPopup, updateShowPopup] = useState(show ?? false);
    const [hideSqlOption, updateHideSqlOption] = useState(false);
    const alwaysSqlHideWarning = useSelector((state) => chatGPTReducer.getAlwaysHideSqlWarning(state));
    const updateAlwaysHideSqlWarning = (boolean) => dispatch(chatGPTReducer.updateAlwaysHideSqlWarning(boolean));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const isModelTitan = modelId === MODELS.TITAN;
    const defaultSqlWarningTitle = "The NLQ agent template will show row level data";
    const defaultSqlWarningText = "This will remove the anonymization protections provided by the Aible Information Model and your selected LLM will have access to the data. Would you like to continue to the natural language query agent template?";
    const notOptimizedWarningTitle = "LLM not optimized for NLQ and this agent template will show row level data";
    const notOptimizedWarningText = "Your selected LLM may not generate correct SQL queries necessary for the NLQ agent template. Also, this agent template will remove the anonymization protections provided by the Aible Information Model and your selected LLM will have access to the data. Would you like to continue to the natural language query agent template?";
    const [warningTitle, updateWarningTitle] = useState(defaultSqlWarningTitle);
    const [warningText, updateWarningText] = useState(defaultSqlWarningText);
    useEffect(() => {
        if (isModelTitan) {
            updateWarningTitle(notOptimizedWarningTitle);
            updateWarningText(notOptimizedWarningText);
        }
        else {
            updateWarningTitle(defaultSqlWarningTitle);
            updateWarningText(defaultSqlWarningText);
        }
        if (chatType === "SQL" && alwaysSqlHideWarning !== true) {
            updateShowPopup(true);
        }
        else if (showPopup === true) {
            updateShowPopup(false);
            updateHideSqlOption(false);
        }
    }, [chatType, modelId]);
    return (React.createElement(React.Fragment, null, showPopup === true && isAsking !== true && (React.createElement("div", { className: isNewChat ? styles.sqlWarningContainerNewChat : styles.sqlWarningContainer },
        React.createElement("div", { className: styles.sqlWarningWrapper, style: style },
            React.createElement("div", { className: styles.sqlWarningHeader },
                React.createElement("img", { className: styles.sqlWarningIcon, src: WarningIcon }),
                React.createElement("div", { className: styles.sqlWarningTitle }, warningTitle)),
            React.createElement("div", { className: styles.sqlWarningContent }, warningText),
            React.createElement("div", { className: styles.sqlWarningFooter },
                React.createElement(Button, { type: "primary", onClick: () => {
                        if (hideSqlOption == true) {
                            updateAlwaysHideSqlWarning(true);
                            updateHideSqlOption(false);
                        }
                        updateShowPopup(false);
                    } }, "Continue to NLQ Agent Template"),
                React.createElement("a", { className: styles.sqlCancelButton, onClick: () => {
                        dispatch(chatGPTReducer.selectBlueprint(DEFAULT_BLUEPRINT_ID));
                        updateShowPopup(false);
                        updateHideSqlOption(false);
                    } }, "Go Back"),
                React.createElement("div", { className: styles.sqlCheckboxContainer, onClick: () => {
                        if (hideSqlOption === false) {
                            updateHideSqlOption(true);
                        }
                        else {
                            updateHideSqlOption(false);
                        }
                    } },
                    React.createElement("input", { className: styles.sqlWarningCheckbox, type: "checkbox", name: "hideSqlOption", checked: hideSqlOption === true }),
                    React.createElement("span", { className: styles.sqlCheckboxLabel }, "Don't show this alert again"))))))));
};
export default SqlWarningPopup;
